import * as SegmentCommon from './components/SegmentCommon/SegmentCommon.css';
import * as SegmentCompact from './components/SegmentCompact/SegmentCompact.css';
export default {
    SegmentCommon,
    SegmentCompact
};
